<template>
  <div class="content">
    <h1 class="content__title">Sectores de inversion</h1>
    <span class="content__details">Listado sectores de inversión</span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Lista de sectores</h2>
          <div class="main__results">
            <div class="result" v-if="sectors === 'loading'">
              <div class="result__data">
                <img class="result__loading" src="/static/img/waiting.gif" alt="Cargando información">
              </div>
            </div>
            <div class="result" v-else-if="!sectors">
              <div class="result__data">
                <h2 class="result__title">No se encontraron resultados</h2>
              </div>
            </div>
            <entry-component @update="getSectors" v-else v-for="(sector, index) in sectors" :key="index" :entry="sector"></entry-component>

          </div>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">OPCIONES</h2>
        <button class="btn btn--small btn__default" @click.prevent="newSector">Nuevo Sector</button>
      </aside>
    </div>
  </div>
</template>

<script>
import httpService from "@/api/request";
import entryComponent from "./entry";
export default {
  mixins: [httpService],
  components: {
    entryComponent
  },
  data: function() {
    return {
      sectors: "loading"
    };
  },
  created: function() {
    this.getSectors();
  },
  methods: {
    getSectors: function() {
      let httpRequest = {
        module: "sectors",
        params: ""
      };
      this.get(httpRequest)
        .then(sectors => {
          this.sectors = sectors.data;
        })
        .catch(() => {
          this.sectors = null;
        });
    },
    newSector: function() {
      this.sectors.push({
        id: null,
        name_es: null,
        name_en: null,
        color: null
      });
    }
  }
};
</script>

<style lang="sass">
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/sectors/list.vue